import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';


const ucbScSideNav = {
  id: 'sc',
  children: [
      {
      id: 'scDsaMenu',
      displayName: 'DSA',
      role: 'SC_INCTV_CLAIM_VIEW',
      icon: fas.faTag,
      precedence: 11,
      children: [
        { id: 'scInctvDashboard', displayName: 'DSA/SD Dashboard', role: 'SC_INCTV_CLAIM_VIEW', icon: fas.faChartLine, route: '/sc/dashboard/inctv-claim', precedence: 30 },
        { id: 'scForecastDashboard', displayName: 'Forecast Dashboard', role: 'SC_FEES_FORECAST_VIEW', icon: fas.faChartLine, route: '/sc/dashboard/fees-forecast', precedence: 31 },
        { id: 'scInctvPerspective', displayName: 'Perspective', role: 'SC_INCTV_CLAIM_LINE_VIEW', icon: fas.faDollarSign, route: '/sc/inctv-claim-line', precedence: 14, state: { mode: Mode.PERSPECTIVE } },
        { id: 'scForecastPerspective', displayName: 'DSA Forecasting', role: 'SC_FEES_FORECAST_VIEW', icon: fas.faDollarSign, route: '/sc/fees-forecast', precedence: 32, state: { mode: Mode.PERSPECTIVE } }
                
      ]
    },
    {
      id: 'scMcoMenu',
      displayName: 'MCO',
      role: 'SC_MCO_CLAIM_VIEW',
      icon: fas.faClinicMedical,
      precedence: 14,
      children: [
        { id: 'scMcoPhsCapDashboard', displayName: '340B Cap Dashboard', role: 'SC_MCO_INV_VIEW', icon: fas.faChartBar, route: '/sc/mco-phs-cap-dashboard', precedence: 21 },
      ]
    }
  ]
}

export default ucbScSideNav;